// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2 - PREVIEW ONLY)
// version  : 1.0
// updated  : 2026-06-19
// protected: NO
// =============================================================================
// Placeholder modul yang dibangun pada fase berikutnya (C2-C5).
import React from "react";
import { Card } from "@/components/ui/card";
import { Construction } from "lucide-react";

export const Placeholder = ({ title }) => (
  <Card className="p-10 rounded-2xl text-center max-w-xl mx-auto" data-testid="v2-placeholder">
    <div className="flex justify-center mb-3"><Construction className="w-10 h-10 text-muted-foreground" /></div>
    <h2 className="text-xl font-semibold">{title}</h2>
    <p className="text-sm text-muted-foreground mt-2">
      Modul ini sedang dibangun pada fase berikutnya. Backend ledger V2 untuk fitur ini sudah siap & teruji;
      antarmuka akan ditambahkan sesuai roadmap (PREVIEW ONLY).
    </p>
  </Card>
);
